export function PhoneIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={21}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 20"
        >
            <path
                d="M6.35 4.167c.05.741.175 1.466.375 2.158l-1 1c-.342-1-.558-2.058-.633-3.158H6.35zm8.217 10.016c.708.2 1.433.325 2.166.375V15.8a12.856 12.856 0 01-3.166-.625l1-.992zM7.15 2.5H4.233a.836.836 0 00-.833.833C3.4 11.158 9.742 17.5 17.567 17.5a.836.836 0 00.833-.833v-2.909a.836.836 0 00-.833-.833 9.506 9.506 0 01-2.975-.475.7.7 0 00-.259-.042.854.854 0 00-.591.242l-1.834 1.833a12.624 12.624 0 01-5.491-5.491L8.25 7.158a.836.836 0 00.208-.85 9.467 9.467 0 01-.475-2.975.836.836 0 00-.833-.833z"
                fill="#D4171E"
                className={mainClassName}
            />
        </svg>
    );
}


export function CartIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={21}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 20"
        >
            <path
                d="M3.146 3.583L2.443 1.25H.1m3.046 2.333l2.813 9.334h12.89v-7a2.339 2.339 0 00-2.343-2.334H3.146zm13.36 15.167a1.17 1.17 0 01-1.172-1.167 1.17 1.17 0 011.172-1.166 1.17 1.17 0 011.172 1.166 1.17 1.17 0 01-1.172 1.167zM7.13 17.583a1.17 1.17 0 011.172-1.166 1.17 1.17 0 011.172 1.166 1.17 1.17 0 01-1.172 1.167 1.17 1.17 0 01-1.172-1.167z"
                stroke="#D4171E"
                strokeWidth={1.25}
                className={strokeClassName}
            />
        </svg>
    );
}


export function GeoIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={16}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 16 17"
        >
            {/* <path fill="#fff" d="M0 .5h16v16H0z" /> */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.162 2.99a3.689 3.689 0 013.676 0l.002.001a4.314 4.314 0 012.05 2.8c.27 1.19.038 2.44-.637 3.445l-2.996 4.459a.31.31 0 01-.257.138.31.31 0 01-.257-.138L4.747 9.236a4.434 4.434 0 01-.637-3.445 4.315 4.315 0 012.05-2.8h.002zM8 4.109c1.378 0 2.498 1.153 2.498 2.572 0 1.42-1.12 2.573-2.498 2.573-1.378 0-2.497-1.153-2.497-2.573S6.622 4.108 8 4.108z"
                fill="#E11C23"
                className={fillClassName}
            />
        </svg>
    );
}


export function LogoIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={69}
            height={60}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 69 60"
        >
            <g clipPath="url(#prefix__clip0_2276_26085)">
                <ellipse cx={34.475} cy={21} rx={33.917} ry={19.5} fill="#fff" />
                <ellipse
                    cx={34.475}
                    cy={21.046}
                    rx={29.984}
                    ry={18.908}
                    fill="#D5171E"
                    className={fillClassName}
                />
                <path
                    d="M52.465 16.991c-3.646-3.572-8.124-5.528-10.027-6.06l.384 1.185c4.452 1.349 7.74 3.736 8.731 4.875h.912zM14.518 17.081h-.816c1.766-1.895 6.173-4.556 8.156-5.65v1.185c-2.034.838-5.981 3.326-7.34 4.465z"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth={1.549}
                />
                <path
                    d="M38.553 21.956c8.213-4.228 4.653-11.102 1.823-13.987-2.975 1.594-12.953 13.167-9.067 14.625 3.108 1.166 6.124.06 7.244-.638z"
                    fill="#fff"
                />
                <path
                    d="M21.946 12.916c1.64 4.896 6.389 4.759 10.01 4.448 1.512-2.833 5.83-7.48 8.42-9.394-4.082-4.212-10.233-3.708-12.987-2.952-2.414.545-7.1 2.949-5.443 7.898z"
                    fill="#fff"
                />
                <path
                    d="M22.924 10.645c.308 3.754 6.909 4.905 10.17 5.012.923-1.64 3.966-4.723 5.373-6.06-.537-.364-2.367-1.124-3.214-1.458-3.31-1.184-12.712-2.187-12.329 2.506zM39.426 10.28c-1.036.802-3.214 3.463-4.173 4.693-.064.094-.307.49 0 .482 1.727-.045 2.975-.957 3.07-.729.077.182-.32.562-.527.73-1.036.838-2.959 1.637-3.79 1.932-1.152 2.442.096 3.326.863 3.463 3.032.583 5.133-.73 5.805-1.458 4.145-3.973.895-7.73-1.248-9.112z"
                    fill="#D5171E"
                    className={fillClassName}
                />
                <path
                    d="M42.457 6.976c-.28.062-1.568.797-2.177 1.157l.428.656c.404-.308 1.93-1.106 2.643-1.466-.182-.141-.614-.409-.894-.347zM16.005 33.666h-.575c2.11-3.371 9.364-9.75 19.19-9.75 9.824 0 17.078 6.378 19.189 9.75h-.576c-1.759-2.81-8.52-8.565-18.614-8.565-10.093 0-16.743 5.755-18.614 8.565z"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth={1.549}
                />
                <path
                    d="M34.714 31.48c-12.972 0-18.581-4.86-19.765-7.29h-1.535c1.44 2.915 7.714 8.747 21.3 8.747 13.587 0 19.798-5.832 21.205-8.747h-1.535c-1.152 2.43-6.697 7.29-19.67 7.29zM12.55 21.41c0 1.202.576 2.353.864 2.779h1.488c-.832-1.367-1.632-4.238.527-4.238 1.871 0 1.088 2.233.288 3.372l1.103.729c.672-.911 1.312-2.05 1.344-2.734 0-2.187-1.535-2.642-3.023-2.642-1.487 0-2.59 1.23-2.59 2.733zM56.734 21.364c0 1.203-.527 2.4-.815 2.825h-1.535c.831-1.367 1.63-4.282-.528-4.282-1.871 0-1.087 2.232-.288 3.371l-1.103.729c-.672-.911-1.312-2.05-1.344-2.734 0-2.186 1.536-2.642 3.023-2.642s2.59 1.23 2.59 2.733z"
                    fill="#fff"
                />
            </g>
            <path
                d="M4.516 53.188l-.888-.432 3.432-8.28c.104-.232.264-.348.48-.348.24 0 .408.116.504.348l3.432 8.292-.852.42-3.192-7.824h.228l-3.144 7.824zm-1.2 2.388a.503.503 0 01-.372-.144.503.503 0 01-.144-.372v-1.992c0-.152.048-.276.144-.372a.503.503 0 01.372-.144H11.8c.152 0 .276.048.372.144.096.096.144.22.144.372v1.992a.503.503 0 01-.144.372.503.503 0 01-.372.144.503.503 0 01-.372-.144.503.503 0 01-.144-.372V53.5H3.832v1.56a.503.503 0 01-.144.372.48.48 0 01-.372.144zm13.21-2.004A3.265 3.265 0 0115 53.224a2.622 2.622 0 01-1.044-1.044c-.256-.456-.384-1.016-.384-1.68v-3.06a.488.488 0 01.504-.504.488.488 0 01.504.504v3.06c0 .488.092.888.276 1.2.184.304.432.536.744.696a2.38 2.38 0 001.056.228c.376 0 .716-.072 1.02-.216.304-.152.544-.352.72-.6a1.51 1.51 0 00.264-.876h.684a2.688 2.688 0 01-.396 1.356 2.705 2.705 0 01-1.008.936 2.9 2.9 0 01-1.416.348zm2.64-.072a.529.529 0 01-.373-.132.546.546 0 01-.132-.384V47.44c0-.152.044-.272.132-.36a.503.503 0 01.372-.144c.152 0 .276.048.372.144a.464.464 0 01.144.36v5.544c0 .16-.048.288-.144.384a.529.529 0 01-.372.132zm3.188 0a.546.546 0 01-.384-.132.546.546 0 01-.132-.384V47.44a.528.528 0 01.144-.36.503.503 0 01.372-.144c.152 0 .272.048.36.144a.48.48 0 01.144.372v2.208h2.46v.192c.424 0 .8.076 1.128.228.336.152.596.364.78.636.184.264.276.568.276.912 0 .368-.092.692-.276.972-.184.28-.444.5-.78.66-.328.16-.704.24-1.128.24h-2.964zm.504-.936h2.46c.352 0 .636-.088.852-.264.224-.176.336-.424.336-.744 0-.328-.112-.58-.336-.756-.216-.184-.5-.276-.852-.276h-2.46v2.04zm1.356-2.34v-.564h1.164a.804.804 0 00.624-.264.934.934 0 00.252-.672.798.798 0 00-.276-.612.918.918 0 00-.66-.252h-2.952v-.924h2.952c.368 0 .692.076.972.228.288.144.516.344.684.6.168.256.252.552.252.888 0 .504-.176.892-.528 1.164-.344.272-.784.408-1.32.408h-1.164zm7.675 3.336a3.11 3.11 0 01-1.632-.432 3.222 3.222 0 01-1.14-1.2 3.449 3.449 0 01-.42-1.704c0-.64.144-1.212.432-1.716.296-.504.696-.9 1.2-1.188a3.301 3.301 0 011.704-.444c.624 0 1.184.148 1.68.444.504.288.9.684 1.188 1.188.296.504.448 1.076.456 1.716l-.408.204c0 .592-.136 1.124-.408 1.596a3.016 3.016 0 01-1.092 1.128 2.986 2.986 0 01-1.56.408zm.144-.912a2.25 2.25 0 001.188-.312c.352-.216.628-.508.828-.876.208-.368.312-.78.312-1.236 0-.464-.104-.876-.312-1.236-.2-.368-.476-.66-.828-.876a2.187 2.187 0 00-1.188-.324c-.44 0-.84.108-1.2.324a2.387 2.387 0 00-.84.876c-.208.36-.312.772-.312 1.236 0 .456.104.868.312 1.236.208.368.488.66.84.876.36.208.76.312 1.2.312zm2.808.852a.557.557 0 01-.372-.132.503.503 0 01-.144-.372v-1.98l.228-1.044.804.252v2.772a.503.503 0 01-.144.372.529.529 0 01-.372.132zm7.905 0a.529.529 0 01-.372-.132.519.519 0 01-.144-.384v-5.532a.48.48 0 01.144-.372.503.503 0 01.372-.144.45.45 0 01.348.144.503.503 0 01.132.372v5.532c0 .16-.044.288-.132.384a.47.47 0 01-.348.132zm-5.1 0a.513.513 0 01-.36-.132.546.546 0 01-.132-.384v-5.532c0-.16.044-.284.132-.372a.488.488 0 01.36-.144c.152 0 .272.048.36.144a.48.48 0 01.144.372v5.532c0 .16-.048.288-.144.384a.486.486 0 01-.36.132zm.348-2.88v-.912h4.56v.912h-4.56zm9.487.876c-.584 0-1.072-.124-1.464-.372a2.347 2.347 0 01-.876-1.044c-.2-.448-.3-.968-.3-1.56v-1.068c0-.16.044-.284.132-.372a.519.519 0 01.384-.144c.152 0 .272.048.36.144a.48.48 0 01.144.372v1.068c0 .616.14 1.108.42 1.476.288.368.736.552 1.344.552.488 0 .884-.084 1.188-.252.312-.176.468-.4.468-.672h.516c0 .36-.104.68-.312.96-.2.28-.472.504-.816.672-.344.16-.74.24-1.188.24zm2.316 2.004a.546.546 0 01-.384-.132.546.546 0 01-.132-.384v-5.532c0-.16.044-.284.132-.372a.519.519 0 01.384-.144c.152 0 .272.048.36.144a.48.48 0 01.144.372v5.532c0 .16-.048.288-.144.384a.486.486 0 01-.36.132zm5.494.072a3.265 3.265 0 01-1.524-.348 2.622 2.622 0 01-1.044-1.044c-.256-.456-.384-1.016-.384-1.68v-3.06a.488.488 0 01.504-.504.488.488 0 01.504.504v3.06c0 .488.092.888.276 1.2.184.304.432.536.744.696a2.38 2.38 0 001.056.228c.376 0 .716-.072 1.02-.216.304-.152.544-.352.72-.6a1.51 1.51 0 00.264-.876h.684a2.688 2.688 0 01-.396 1.356 2.705 2.705 0 01-1.008.936 2.9 2.9 0 01-1.416.348zm2.64-.072a.529.529 0 01-.372-.132.546.546 0 01-.132-.384V47.44c0-.152.044-.272.132-.36a.503.503 0 01.372-.144c.152 0 .276.048.372.144a.464.464 0 01.144.36v5.544c0 .16-.048.288-.144.384a.529.529 0 01-.372.132zm7.844-.132a.486.486 0 01-.36.132.45.45 0 01-.348-.144l-2.892-3.144 2.748-3.12a.489.489 0 01.348-.156.457.457 0 01.348.108c.104.096.16.204.168.324a.402.402 0 01-.108.324l-2.232 2.472 2.352 2.568a.467.467 0 01.132.324c0 .112-.052.216-.156.312zm-4.692.132a.47.47 0 01-.348-.132.529.529 0 01-.132-.372v-5.544c0-.16.044-.284.132-.372a.45.45 0 01.348-.144.48.48 0 01.372.144.48.48 0 01.144.372v2.256h1.488v.936H61.6v2.352a.503.503 0 01-.144.372.503.503 0 01-.372.132z"
                fill="#D5171E"
                className={fillClassName}
            />
            <defs>
                <clipPath id="prefix__clip0_2276_26085">
                    <path fill="#fff" transform="translate(0 1.5)" d="M0 0h69v39H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}


export function CatalogIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 21"
        >
            <g clipPath="url(#prefix__clip0_2276_26106)" fill="#fff" className={fillClassName}>
                <rect x={0.5} y={6.5} width={20} height={2} rx={1} />
                <rect x={0.5} y={12.5} width={13} height={2} rx={1} />
            </g>
            <defs>
                <clipPath id="prefix__clip0_2276_26106">
                    <path fill="#fff" className={fillClassName} transform="translate(.5 .5)" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function CatalogIconHeader({ mainClassName, fillClassName }) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 21"
        >
            <g clipPath="url(#prefix__clip0_2276_26106)" fill="#fff" className={fillClassName}>
                <rect x={0.5} y={6.5} width={20} height={2} rx={1} />
                <rect x={0.5} y={12.5} width={13} height={2} rx={1} />
            </g>
            <defs>
                <clipPath id="prefix__clip0_2276_26106">
                    <path fill="#fff" className={fillClassName} transform="translate(.5 .5)" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}




export function RoomsIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 21 21"
        >
            <path
                d="M8.278 2.5H2.5v8.444M11.389 9.5v-7H18.5v9.778m0 0V18.5h-16v-7.556m16 1.334h-4.444M2.5 10.944h5.778"
                stroke="#D4171E"
                strokeWidth={2}
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function SearchIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={25}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 25 24"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 21.812c5.523 0 10-4.44 10-9.915 0-5.475-4.477-9.914-10-9.914s-10 4.439-10 9.914c0 5.476 4.477 9.915 10 9.915zm0 1.983c6.627 0 12-5.327 12-11.898C24.5 5.327 19.127 0 12.5 0S.5 5.327.5 11.897c0 6.571 5.373 11.898 12 11.898z"
                fill="#D5171E"
                className={fillClassName}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.793 22.598l3.5-3.47 1.414 1.402-3.5 3.47-1.414-1.402z"
                fill="#D5171E"
                className={fillClassName}
            />
        </svg>
    );
}


export function FavoriteIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 20 20"
        >
            <path
                d="M2.544 10.044L10 17.5l7.456-7.456a4.42 4.42 0 10-6.25-6.25L10 5 8.794 3.794a4.42 4.42 0 00-6.25 6.25z"
                stroke="#000"
                strokeWidth={1.25}
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function ArrowIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 24"
        >
            <path
                d="M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 000-1.41L9.15 2.98a1.25 1.25 0 00-1.77 0 1.25 1.25 0 000 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76z"
                fill="#E11C23"
                className={fillClassName}
            />
        </svg>
    );
}


export function MenuIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={34}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 34 34"
        >
            <path
                d="M5.667 25.5h22.666a1.42 1.42 0 001.417-1.417 1.42 1.42 0 00-1.417-1.416H5.667a1.42 1.42 0 00-1.417 1.416c0 .78.638 1.417 1.417 1.417zm0-7.083h22.666A1.42 1.42 0 0029.75 17a1.42 1.42 0 00-1.417-1.417H5.667A1.42 1.42 0 004.25 17c0 .78.638 1.417 1.417 1.417zm-1.417-8.5c0 .779.638 1.416 1.417 1.416h22.666a1.42 1.42 0 001.417-1.416A1.42 1.42 0 0028.333 8.5H5.667A1.42 1.42 0 004.25 9.917z"
                fill="#000"
                className={fillClassName}
            />
        </svg>
    );
}

export function CloseIcon({ mainClassName, fillClassName }) {
    return (
      <svg
        width={34}
        height={34}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={mainClassName}
        viewBox="0 0 34 34"
      >
        <path
          d="M25.925 8.089a1.41 1.41 0 00-1.998 0L17 15.002l-6.928-6.927a1.41 1.41 0 00-1.997 0 1.41 1.41 0 000 1.997L15.003 17l-6.928 6.927a1.41 1.41 0 000 1.997 1.41 1.41 0 001.998 0L17 18.997l6.927 6.927a1.41 1.41 0 001.998 0 1.41 1.41 0 000-1.997L18.997 17l6.928-6.928a1.42 1.42 0 000-1.983z"
          fill="#000"
          className={fillClassName}
        />
      </svg>
    );
  }
